import { Box } from '@mui/material'
import { DateTime } from 'luxon'
import { Port } from '../../types/models'
import { ClockPort, ClockConfig } from '../../types/ports'
import { lang } from '../../utils/lang'
import { DeviceControl } from '../DeviceControl'
import { PortControl } from './PortControl'

/**
 * Controller for temperature meter.
 */
export class ClockPortControl extends PortControl<ClockPort, ClockConfig> {

  port: ClockPort

  constructor(deviceControl: DeviceControl, port: Port) {
    super(deviceControl, port)
    this.port = port as ClockPort
  }

  getDescription(): string { return this.app.t('Device Clock') }

  getTypeName(): string { return this.app.t('PortType-Clock') }

  get group(): string { return this.app.t('PortGroup-Info') }

  infoTop() : React.ReactNode | undefined {
    const value = this.port.values.clock
    const time = value ? DateTime.fromISO(value).toLocal() : undefined

    return <Box>
      <Box>{time ? time.setLocale(lang.current() || 'en').toLocaleString(DateTime.DATETIME_FULL) : <>—</>}</Box>
    </Box>
  }
}
